export default __webpack_public_path__ + "static/media/logo-page.c20717dc.png";